import { status } from '../../helpers'

const getIntegrationsStoreDefaultState = () => {
  return {
    integrationListLoading: false,
    integrationListLoaded: false,
    integrations: [],
    loadingSalesforceByResourceType: status.INITIALIZED,
    salesForceRecords: []
  }
}

export default getIntegrationsStoreDefaultState
